import { BankOutlined, CreditCardOutlined, PieChartOutlined } from "@ant-design/icons";
import { Button, Card, Flex } from "antd";
import styled from "styled-components";

const StyledActiveCard = styled(Card)`
  cursor: pointer;
  margin-right: 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  &:hover {
    box-shadow: #f5f5f5 0px 0px 2px inset;
  }
  @media (max-width: 768px) {
    margin-right: 0;
  }
`;

const StyledCreditCardOutlined = styled(CreditCardOutlined)`
  padding: 0px 16px;
  font-size: 24px;
  margin-right: 8px;
  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 8px;
  }
`;

const StyledBankOutlined = styled(BankOutlined)`
  padding: 0px 16px;
  font-size: 24px;
  margin-right: 8px;
  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 8px;
  }
`;

const StyledPieChartOutlined = styled(PieChartOutlined)`
  padding: 0px 16px;
  font-size: 24px;
  margin-right: 8px;
  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 8px;
  }
`;

const StyledHeader = styled.h3`
  margin-bottom: 0;
  margin-top: 0;
`;

const StyledDiv = styled.div`
  color: gray;
`;

const StyledFlex = styled(Flex)`
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const InnerFlex = styled(Flex)`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
  }
`;

const ContentWrapper = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const StyledButton = styled(Button)`
  min-width: 200px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

/*
    PaymentScheduleCard component
    Displays a card with selector of Full / Partial / Payment Plan
    @param {function} onSelect - function to call when card is selected
    @param {string} type - type of payment schedule, one of "full", "partial", "plan"

    @returns {JSX.Element}
*/
export default function PaymentScheduleCard({ onSelect, type }) {
  return (
    <StyledActiveCard
    // @ts-ignore
    >
      <Flex justify="space-between" align="center" onClick={() => onSelect(type)}>
        <StyledFlex align="center" justify="space-between">
          <InnerFlex>
            {type === "full" && <StyledCreditCardOutlined />}
            {type === "partial" && <StyledPieChartOutlined />}
            {type === "plan" && <StyledBankOutlined />}
            {type === "full" && (
              <ContentWrapper>
                <StyledHeader>Full Payment</StyledHeader>
                <StyledDiv>Pay your balance in full with a single payment. This is</StyledDiv>
                <StyledDiv>a quick and easy way to pay off your current balance.</StyledDiv>
              </ContentWrapper>
            )}
            {type === "partial" && (
              <ContentWrapper>
                <StyledHeader>Partial Payment</StyledHeader>
                <StyledDiv>Make a single payment towards your balance.</StyledDiv>
              </ContentWrapper>
            )}
            {type === "plan" && (
              <ContentWrapper>
                <StyledHeader>Payment Plan</StyledHeader>
                <StyledDiv>Create a payment plan to pay your balance over time.</StyledDiv>
              </ContentWrapper>
            )}
          </InnerFlex>
          {type === "full" && (
            <StyledButton size="large" type="primary">
              Pay in Full
            </StyledButton>
          )}
          {type === "partial" && (
            <StyledButton size="large" type="primary">
              Make Partial Payment
            </StyledButton>
          )}
          {type === "plan" && (
            <StyledButton size="large" type="primary">
              Create Payment Plan
            </StyledButton>
          )}
        </StyledFlex>
      </Flex>
    </StyledActiveCard>
  );
}
